var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMailIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 24,
    viewBox: "0 0 32 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 0C1.34375 0 0 1.34375 0 3C0 3.94375 0.44375 4.83125 1.2 5.4L14.8 15.6C15.5125 16.1313 16.4875 16.1313 17.2 15.6L30.8 5.4C31.5562 4.83125 32 3.94375 32 3C32 1.34375 30.6562 0 29 0H3ZM0 7V20C0 22.2062 1.79375 24 4 24H28C30.2062 24 32 22.2062 32 20V7L18.4 17.2C16.975 18.2688 15.025 18.2688 13.6 17.2L0 7Z",
    fill: "#3F69FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMailIcon);
export default __webpack_public_path__ + "static/media/mail-icon.f12c484c1533394691fb7ecaf19b7860.svg";
export { ForwardRef as ReactComponent };